import styled from 'styled-components';

export const InputWrapper = styled.div`
  width: 100%;
  display: block;
`;